import { useLayoutEffect } from 'react';
import { useAppStore } from '../store/appStore';
import type { Surface, Theme } from '../store/appStore';

/**
 * Fija el tema visual y la superficie activa según la pantalla montada.
 * Bolsillo va en claro; Cabina y Pantalla en navy institucional. Se aplica el
 * atributo `data-theme` en el <html> (misma llave que usa Tailwind y tokens.css)
 * con useLayoutEffect para evitar un parpadeo de tema al navegar.
 *
 * La PREFERENCIA MANUAL (botón claro/oscuro, persistida en localStorage) le
 * gana al default de la superficie — salvo con `respetarPreferencia: false`
 * (la Pantalla proyecta a 6 metros: navy siempre, decisión de legibilidad).
 */
export function useSurfaceTheme(
  surface: Surface,
  theme: Theme,
  opciones: { respetarPreferencia?: boolean } = {},
): void {
  const { respetarPreferencia = true } = opciones;
  const setSurface = useAppStore((s) => s.setSurface);
  const setTheme = useAppStore((s) => s.setTheme);
  const temaElegido = useAppStore((s) => s.temaElegido);

  const efectivo: Theme = respetarPreferencia ? (temaElegido ?? theme) : theme;

  useLayoutEffect(() => {
    document.documentElement.setAttribute('data-theme', efectivo);
    setTheme(efectivo);
    setSurface(surface);
  }, [surface, efectivo, setSurface, setTheme]);
}
